import BookingData from "@/classes/BookingData"
import Fee from "@/model/Fee/Fee"
import FeeFactory from "@/model/Fee/FeeFactory"

import { FeeQuote, QuoteState } from "@requests"

const processFees = (bookingData: BookingData, sourceObj: QuoteState) => {
    // create fee objects
    sourceObj.fee.forEach((feeObj: FeeQuote) => {
        const fee: Fee = FeeFactory.createFee(feeObj)
        bookingData.feesArr.push(fee)
        bookingData.feesMap.set(fee.getReference(), fee)
    })
}

export default processFees